import { COLOR } from '@/utils/enum'

const ColorStyles = {
  [COLOR.BRAND_INDIGO]: '#7B61FF',
  [COLOR.BRAND_GREEN]: '#11A151',
  [COLOR.BRAND_YELLOW]: '#FFC800',
  [COLOR.BRAND_RED]: '#F15C30',
}

/**
 * @param {string | [string]} color
 * @returns string | [string]
 */
export const getStyleColor = (color) => {
  if (typeof color === 'string') {
    return ColorStyles[color]
  }

  return color.map((c) => ColorStyles[c])
}

export default {
  methods: {
    getStyleColor,
  },
}
